import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss';
import ArrowLeft from '/chat/src/components/SVGImages/ArrowLeft'
import SystemModel from '/chat/src/redux/model/system/model';

class BackButton extends Component{
    render() {
        const callback = this.props.callback;

        let defaultStyle = style.NormalBackButton
        if(this.props.isMobile)  defaultStyle = style.MobileBackButton

        return (
            <div className={defaultStyle} onClick={() => {
                if(this.props.callback){
                    this.props.callback();
                }else{
                    this.props.dispatch(SystemModel.goBack());
                }
            }}>
                <ArrowLeft color='white'/>
            </div>
        )
    }
}

export default connect((state) => {
    return {
        isMobile: SystemModel.isMobile(state)
    }
})(BackButton);



// WEBPACK FOOTER //
// ./components/Buttons/BackButton/index.js